import {
  GET_ASSESSMENT_TEST_DETAILS,
  GET_ASSESSMENT_TEST_DETAILS_SUCCESS,
  GET_ASSESSMENT_TEST_DETAILS_FAILED,
  GET_ASSESSMENT_TEST_QUESTIONS,
  GET_ASSESSMENT_TEST_QUESTIONS_SUCCESS,
  GET_ASSESSMENT_TEST_QUESTIONS_FAILED,
  FINISH_ASSESSMENT_TEST,
  FINISH_ASSESSMENT_TEST_SUCCESS,
  FINISH_ASSESSMENT_TEST_FAILED,
} from "./actionTypes";

const initialState = {
  loading: false,
  testData: null,
  testDataFailed: null,
  finishTestSuccess: null,
  finishTestFailed: null,
  questions: null,
  questionsError: null,
};

const assesmentTestReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ASSESSMENT_TEST_DETAILS:
      state = {
        ...state,
        loading: true,
        testData: null,
        testDataFailed: null,
      };
      break;
    case GET_ASSESSMENT_TEST_DETAILS_SUCCESS:
      state = {
        ...state,
        loading: false,
        testData: action.payload,
        testDataFailed: null,
      };
      break;
    case GET_ASSESSMENT_TEST_DETAILS_FAILED:
      state = {
        ...state,
        loading: false,
        testData: null,
        testDataFailed: action.payload,
      };
      break;
    case GET_ASSESSMENT_TEST_QUESTIONS:
      state = {
        ...state,
        loading: false,
        questions: null,
        questionsError: null,
      };
      break;
    case GET_ASSESSMENT_TEST_QUESTIONS_SUCCESS:
      state = {
        ...state,
        loading: false,
        questions: action.payload,
        questionsError: null,
      };
      break;
    case GET_ASSESSMENT_TEST_QUESTIONS_FAILED:
      state = {
        ...state,
        loading: false,
        questions: null,
        questionsError: action.payload,
      };
      break;
    case FINISH_ASSESSMENT_TEST:
      state = {
        ...state,
        loading: true,
        finishTestSuccess: null,
        finishTestFailed: null,
      };
      break;
    case FINISH_ASSESSMENT_TEST_SUCCESS:
      state = {
        ...state,
        loading: false,
        finishTestSuccess: action.payload,
        finishTestFailed: null,
      };
      break;
    case FINISH_ASSESSMENT_TEST_FAILED:
      state = {
        ...state,
        loading: false,
        finishTestSuccess: null,
        finishTestFailed: action.payload,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};
export default assesmentTestReducer;
